import { doc, setDoc } from "firebase/firestore";
import { db } from "../firebase";
import Cookies from "js-cookie";
import { Save_log_history } from "../log_history_root/save_log_history";

export const Update_companytable_info = async (data) => {
    const { servicetablename, filename, fileuid, textinfo } = data || {};

    if (!servicetablename?.trim()) return { success: false, error: "Missing servicetablename" };
    if (!filename?.trim()) return { success: false, error: "Missing filename" };
    if (!fileuid?.trim()) return { success: false, error: "Missing fileuid" };
    if (!textinfo?.trim()) return { success: false, error: "Missing textinfo" };

    // Session validation
    const sessiontoken = Cookies.get("sessiontoken");
    const guid = Cookies.get("guid");
    const select_company_uid = Cookies.get("select_company_uid");

    if (!sessiontoken || !guid) {
        return { success: false, error: "Session expired. Please relogin." };
    }

    if (!select_company_uid || select_company_uid === "undefined") {
        return { success: false, error: "Please select company." };
    }

    try {
        // Save data to company root document
        const docRef = doc(
            db,
            servicetablename,
            select_company_uid
        );

        const payload = {
            [filename]: textinfo,
            updated_at: new Date().toISOString()
        };

        await setDoc(docRef, payload, { merge: true });
        // Log history
        const logData = {
            history_type: "info_change",
            tablename: servicetablename,
            filedname: filename,
            filedid: fileuid,
            log_description: `${filename}: ${textinfo}`,
            log_status: true,
            verify_status: true,
            verify_note: "Info change",
            description: textinfo,
            status: true
        };

        await Save_log_history(logData);

        return { success: true };
    } catch (err) {
        console.error("Error updating info:", err);
        return { success: false, error: err.message || "Unknown error" };
    }
};
